import { render } from "./OverlayEdition.htm?vue&type=template&id=0090ec8d&scoped=true&ts=true"
import script from "./OverlayEdition.vue?vue&type=script&lang=ts"
export * from "./OverlayEdition.vue?vue&type=script&lang=ts"

import "./OverlayEdition.scss?vue&type=style&index=0&id=0090ec8d&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0090ec8d"]])

export default __exports__